"use strict";
import sendUserTimezone from "../utils/sendUserTimezone";
import {default as subscriber} from "../utils/subscribe-actions";
import showPaymentModal from "../utils/payment";
import simpleModal from "../libs/simpleModal";
import {requestSetBookmark} from "../libs/apiv2-requests";

const pageData = {
    cid: typeof cid !== 'undefined' ? cid : 0,
    gid: typeof gid !== 'undefined' ? gid : 0,
    action: window.localStorage.getItem('afterLoginAct') || '',
    args: JSON.parse(window.localStorage.getItem('afterLoginArgs') || '{}')
};

const clearAfterLoginAct = function () {
    window.localStorage.removeItem('afterLoginAct');
    window.localStorage.removeItem('afterLoginArgs');
}

const checkSubscribeAction = function () {
    // actions set from local storage
    if (pageData.action === window.siteActions.subscribe && pageData.gid && user.id) {
        clearAfterLoginAct();
        $.ajax({
            url: '/site/groups/subscribe-after-login',
            data: pageData,
            type: 'post',
            success: function (data) {
                if (data.success) {
                    if (data.modal) {
                        if(data.action === window.siteActions.payment) {
                            showPaymentModal();
                        } else {
                            subscriber.getForm();
                        }
                    }
                    else if (data.alert !== '') {
                        openAlert(data.message, data.alert || 'success');
                    }
                    else if (data.external) {
                        window.open(data.url, "_blank").focus();
                        window.location.reload();
                    }
                }
            },
            error: function () {},
        });
    }
    else if (pageData.action === window.siteActions.bookmark) {
        clearAfterLoginAct();
        requestSetBookmark(pageData.gid || pageData.args.gid, true)
            .then(() => window.location.reload())
    }
};

const checkPlusAction = function () {
    // actions set from local storage
    if (pageData.action === window.siteActions.create_regular) {
        window.getGroupForm('new', 'regular');
        clearAfterLoginAct();
    } else if (pageData.action === window.siteActions.create_checking) {
        window.getGroupForm('new', 'checking');
        clearAfterLoginAct();
    }
}

const checkRunAction = function () {
    // actions set from the server
    const runAction = window.run_action || null;
    const runActionArgs = window.run_action_args || null;
    console.debug('runAction:' + runAction);
    if (runAction === null) {
        return;
    }

    if ((runAction === window.siteActions.payment) && $('#window-payment').length && window.gid) {
        showPaymentModal();
    }
    if ((runAction === window.siteActions.payment_result)) {
        subscriber.finish(...runActionArgs)
    }
    if ((runAction === window.siteActions.calendar) && $('#window-add_to_calendar').length) {
        openWindow('window-add_to_calendar');
    }
    if (runAction === 'auth_message') {
        const message = runActionArgs['message'] || '';
        if (message && translate['auth'][message]) {
            const modal = new simpleModal({
                id: 'RishonAuthStatus',
                header: window.community.title,
                logo: true,
                content: translate['auth'][message],
                footer: `<div class="poweredby">${translate.poweredby}</div>`,
            })
            modal.show()
        }
        if(message === 'rishon_rejected') {
            clearAfterLoginAct();
            $(".windows").find(".open").on('close.cc.modal', function() {
                window.location.href = window.community.url
            })

        }
    }
}

const checkQueryAction = function () {
    const params = new URLSearchParams(window.location.search)
    if (params.get('act') === 'auth') {
        window.auth()
    }
}

export default function (context) {
    if (context === document) {
        
        console.debug('pageData: ' + JSON.stringify(pageData))

        try {
            if (typeof window.run_timezone !== 'undefined') {
                sendUserTimezone(run_timezone).finally(result => console.debug(result));
            }

            checkRunAction()
            checkQueryAction()
            checkSubscribeAction()
            checkPlusAction()
            clearAfterLoginAct()
            // other actions
        } catch (e) {
            console.log(e);
        }
    }
}
